import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: () => import('./views/Home.vue'),
      redirect: '/dashboard',
      children: [
        {
          path: 'dashboard',
          name: 'dashboard',
          component: () => import('./views/Dashboard.vue'),
          meta: {
            requiresAuth: true
          },
          children: [
            {
              path: 'new-network',
              name: 'newNetwork',
              component: () => import('./views/NetworkModal.vue')
            },
            {
              path: ':networkDescription/new-node',
              name: 'newNode',
              component: () => import('./views/NodeModal.vue'),
              props: true
            }
          ]
        },
        {
          path: 'billing',
          name: 'billing',
          component: () => import('./views/Billing.vue'),
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue')
    },
    {
      path: '/register',
      name: 'signup',
      component: () => import('./views/Signup.vue')
    },
    {
      path: '/activate',
      name: 'activate',
      component: () => import('./views/ActivateUser.vue')
    },
    {
      path: '/lost',
      name: 'lost',
      component: () => import('./views/LostPassword.vue')
    },
    {
      path: '/reset/:resetKey',
      name: 'reset',
      props: true,
      component: () => import('./views/ResetPassword.vue')
    },
    {
      path: '*',
      component: () => import('./views/NotFound.vue')
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    store
      .dispatch('checkAuth')
      .then(() => {
        next()
      })
      .catch(e => {
        // console.log(e)
        next({ name: 'login' })
      })
  } else {
    next()
  }
})

export default router
